/* src/app/component/dialogs/level-success-dialog/level-success-dialog.component.scss */
p.eonscreen {
  font-size: 2.5rem;
}
h4 {
  font-size: 1.25rem;
  font-weight: normal;
}
p {
  max-width: 75%;
  margin: 0 auto 1rem auto;
}
/*# sourceMappingURL=level-success-dialog.component.css.map */
